var SportDataGatewayStreamObserver = /** @class */ (function () {
    function SportDataGatewayStreamObserver(id, observer, onMessageHandler) {
        this.id = id;
        this.observer = observer;
        this.onMessageHandler = onMessageHandler;
    }
    return SportDataGatewayStreamObserver;
}());
export { SportDataGatewayStreamObserver };
//# sourceMappingURL=SportDataGatewayStreamObserver.js.map